import DOMPurify from 'dompurify'
import languages from 'constants/languages'
import { getParam } from './parameters'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import * as KEYS from 'constants/keys'

export const getCustomer = () => sessionStorage.getItem('customer')

export const shadeColor = (color, percent) => {
  let R = parseInt(color.substring(1, 3), 16)
  let G = parseInt(color.substring(3, 5), 16)
  let B = parseInt(color.substring(5, 7), 16)

  R = parseInt((R * (100 + percent)) / 100, 10)
  G = parseInt((G * (100 + percent)) / 100, 10)
  B = parseInt((B * (100 + percent)) / 100, 10)

  R = R < 255 ? R : 255
  G = G < 255 ? G : 255
  B = B < 255 ? B : 255

  const RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16)
  const GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16)
  const BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16)

  return `#${RR}${GG}${BB}`
}

export const hexToRgbA = (hex, alpha) => {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = `0x${c.join('')}`
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
      ','
    )},${alpha})`
  }
  throw new Error('Bad Hex')
}

export const trimText = (text, length = 100) => {
  if (text && text.length > length) {
    text = text.substr(0, length)
    text = `${text.substr(0, Math.min(text.length, text.lastIndexOf(' ')))}...`
  }

  return text
}

export const stripHtmlTags = (text = '') => text.replace(/<(?:.|\n)*?>/gm, '')

export const parseHtml = (text) => {
  const txt = document.createElement('textarea')
  txt.innerHTML = text
  return txt.value
}

export const stripStyles = (text = '') =>
  text.replace(/<style>[\s\S]*?<\/style>/gm, '')
export const stripScripts = (text = '') =>
  text.replace(/<script>[\s\S]*?<\/script>/gm, '')

export const formatContentType = (string) => {
  const types = {
    tutorial: 'Tutorial',
    tutorials: 'Tutorial',
    guide: 'Guide',
    faq: 'FAQ',
    faqs: 'FAQ',
    pdf: 'PDF'
  }

  return types[string]
}

export const getLanguageId = () =>
  languages[sessionStorage.getItem('language')] || 1

const removeEmpty = (obj) => {
  Object.keys(obj).forEach((key) => obj[key] == null && delete obj[key])
  return obj
}

const buildUrl = (path, params) => `${path}?${queryString.stringify(params)}`

export const fetchGet = async (path, params = {}) => {
  const contentApiToken = await getParam('contentApiToken')
  const defaultParams = {
    customer: getCustomer(),
    language: getLanguageId(),
    ...removeEmpty(params)
  }
  return fetch(buildUrl(path, defaultParams), {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${contentApiToken}`
    }
  })
    .then((response) => response.json())
    .catch((err) => err)
}

export const dynamicSort = (property) => {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export const saveUserMeta = (key, data) => {
  const body = {
    user_metadata: {
      [key]: data
    }
  }
  const userId = localStorage.getItem(KEYS.AUTH_USER_ID)
  const token = localStorage.getItem(KEYS.MANAGEMENT_API_TOKEN)

  return fetch(`https://devicebits-demo.auth0.com/api/v2/users/${userId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  })
    .then((response) => response.json())
    .catch((error) => error)
}

export const getUserMeta = () => {
  const userId = localStorage.getItem(KEYS.AUTH_USER_ID)
  const token = localStorage.getItem(KEYS.JWT_TOKEN)

  return fetch(`https://devicebits-demo.auth0.com/api/v2/users/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => response.json())
    .then((json) => json.user_metadata)
    .catch((error) => error)
}

export const secondsToTimeString = (sec) => {
  let hours = Math.floor(sec / 3600)
  let minutes = Math.floor((sec - hours * 3600) / 60)
  let seconds = sec - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = `0${hours}`
  }
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  if (seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${hours} : ${minutes} : ${seconds}`
}

export const getPersisted = (reducer, key) => {
  const json = sessionStorage.getItem(`reduxPersist:${reducer}`)
  if (json) {
    return JSON.parse(json)[key]
  }
}

const buildParams = (params) => ({
  customer: getCustomer(),
  language: getLanguageId(),
  ...removeEmpty(params)
})

const buildHeaders = () => {
  const token = localStorage.getItem(KEYS.JWT_TOKEN)
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
}

export const fetchCA = async (path, params = {}, method = 'GET', body = '') => {
  const careassistApiUrl = await getParam('careassistApiUrl')
  const options = {
    method,
    headers: buildHeaders()
  }
  if (body) {
    options.body = JSON.stringify(body)
  }

  return fetch(buildUrl(careassistApiUrl + path, buildParams(params)), {
    ...options
  }).then((response) => {
    const json = response.json()

    if (!response.ok) {
      return json.then((err) => {
        throw new Error(err.message)
      })
    }
    return json
  })
}

export const fetchBQ = async (path, params = {}, method = 'GET', body = '') => {
  const analyticsApiUrl = await getParam('analyticsApiUrl')
  const options = {
    method,
    headers: buildHeaders()
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  return fetch(buildUrl(analyticsApiUrl + path, buildParams(params)), {
    ...options
  }).then((response) => {
    const json = response.json()

    if (!response.ok) {
      return json.then((err) => {
        throw new Error(err.message)
      })
    }
    return json
  })
}

export const addMessageListener = (type, callback) => {
  const handler = (e) => {
    if (e.data?.type === type) {
      callback(e.data)
    }
  }
  window.addEventListener('message', handler)
  // return cleanup
  return () => {
    window.removeEventListener('message', handler)
  }
}

export const validURL = (str) => {
  const pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ) // fragment locator
  return !!pattern.test(str)
}

export const triggerWindowEvent = (name) => {
  if (!name) {
    throw new Error('event name required')
  }
  const event = document.createEvent('Event')
  event.initEvent(name, true, true)
  window.dispatchEvent(event)
}

export const postWindowMessage = (name, data) => {
  if (!name) {
    throw new Error('event name required')
  }
  window.postMessage({ type: name, value: data }, '*')
}
export const filterByCustomer = (data = [], customer) => {
  return data.filter((d) => d.customer === customer)
}
export const getCustomers = (user) => {
  const name = (user.careassist && user.careassist.name) || user.name || ''
  const multi =
    (user.careassist && user.careassist.multiLoginCustomers) ||
    user.multiLoginCustomers ||
    []

  return [name, ...multi]
}
export const addQueryParams = (url, params) => {
  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = `http://${url}`
  }
  const normalizedURL = new URL(url)

  for (const param in params) {
    normalizedURL.searchParams.append(param, params[param])
  }
  return normalizedURL.href
}

export const fetchGetJson = async (url, config) => {
  const res = await fetch(url, config)

  if (!res.ok) {
    throw new Error(res.statusText)
  }

  return res.json()
}

export const pipe =
  (...fns) =>
  (x) =>
    fns.reduce((v, f) => f(v), x)

export const sanitizeHTML = (str) => DOMPurify.sanitize(str)

// set unique session id that expires when the browser closes
export const getSessionId = () => {
  const existingId = Cookies.get(KEYS.SESSION_ID)
  if (existingId) {
    return existingId
  }

  const sessionId = Math.uuid()
  Cookies.set(KEYS.SESSION_ID, sessionId)
  return sessionId
}

// set permanent id for a browser
export const getPermanentId = () => {
  const existingId = Cookies.get(KEYS.USER_ID)
  if (existingId) {
    return existingId
  }

  const permanentId = Math.uuid()
  Cookies.set(KEYS.USER_ID, permanentId, {
    expires: 365 * 5
  })
  return permanentId
}

export const getAppInstanceId = () => {
  const appInstanceId = sessionStorage.getItem(KEYS.APP_INSTANCE_ID)
  const appId = !appInstanceId
    ? window.GLOBAL_APP_ID || Math.uuid()
    : appInstanceId
  sessionStorage.setItem(KEYS.APP_INSTANCE_ID, appId)

  return appId
}

/**
 * Return true if the node's tagName is 'SCRIPT', otherwise return false
 * @returns An expression that checks if the node's tagName is 'SCRIPT'
 */
const isScriptNode = node => {
  return node.tagName === 'SCRIPT'
}

/**
 * This creates a new script element, copies the attributes of the original node
 * to the new script element, and sets the text of the new element to the innerHTML
 * of the original node
 * @returns A new script element with the same attributes and text as the original node.
 */
const cloneScriptNode = node => {
  const script = document.createElement('script')
  script.text = node.innerHTML

  for (let attr of node.attributes) {
    script.setAttribute(attr.name, attr.value)
  }

  return script
}

/**
 * If the current node is a script, replace it with a clone of itself,
 * otherwise iterate through its children and call this function recursively
 *
 * @link https://stackoverflow.com/questions/1197575/can-scripts-be-inserted-with-innerhtml
 * @param {HTMLElement} node
 * @returns The node that was passed in.
 */
export const replaceScriptNodes = node => {
  if (isScriptNode(node)) {
    node.parentNode.replaceChild(cloneScriptNode(node), node)
  } else {
    for (let child of node.childNodes) {
      replaceScriptNodes(child)
    }
  }

  return node
}

/**
 * The removeNodeById function removes a node from the DOM by its id.
 * @see AuthContext
 * @param {string} id - Identify the node to be removed
 */
export const removeNodeById = (id = 'lex-web-ui-iframe') => {
  const node = document.getElementById(id)
  if (node) {
    node.remove()
  }
}